import { render, staticRenderFns } from "./SidebarFuelCertificate.vue?vue&type=template&id=190a5e1e&"
import script from "./SidebarFuelCertificate.vue?vue&type=script&lang=js&"
export * from "./SidebarFuelCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports